import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import qs from 'query-string';

const Filter = props => {
  const [pickPackId, setPickPackId] = useState<string>('');

  useEffect(() => {
    const {
      pickPackId,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    setPickPackId(pickPackId?.toString() || '');
  }, []);


  const resetFilter = () => {
    setPickPackId('');

    const filterData = {
      pickPackId: '',
    };
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    if (pickPackId) {
      props.history.push(`/pick-packs/${pickPackId}`);
    } else {
      const filterData = {
        pickPackId,
      };
      props.onSubmit(filterData);
    }
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Pick Pack List ID</div>
        <input
          value={pickPackId}
          className={'form-control'}
          onChange={e => setPickPackId(e.target.value)}
        />
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;